import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای برنامه‌ریزی کلان تولید (MPS)

برنامه کلان تولید (Master Production Schedule) به شما کمک می‌کند تا میزان تولید محصولات نهایی در بازه‌های زمانی مختلف را برنامه‌ریزی کنید.

## ۱. تعریف برنامه
می‌توانید برای هر محصول، تعداد مورد نیاز در هر هفته یا ماه را تعیین کنید.

## ۲. وضعیت برنامه‌ها
تأیید، ویرایش و مشاهده وضعیت پیشرفت هر برنامه کلان در این قسمت انجام می‌شود.

export default Layout;
